import { AuthorizedUser } from '../../models/authorized-user';
import globalAxios, { AxiosInstance, AxiosResponse } from 'axios';
import * as HttpStatus from 'http-status-codes';
import { AuthenticationStatus, AuthenticationStatusType } from './authentication-status';
import { SELF_URL } from '../../config/config';
import { Url } from '../../config/url'
import { RoleType } from '@/trust-atcs-app/models/user';

export default class AuthenticationService {

  private options = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  };

  constructor(
    public authedUser: AuthorizedUser = new AuthorizedUser(),
    public axios: AxiosInstance = globalAxios
  ) { }

  // public async impersonatePractitioner(lawId: string): Promise<boolean> {
  //   console.log('impersonating user .................')
  //   let tokenResp: AxiosResponse;

  //   try {
  //     tokenResp = await this.axios.get(SELF_URL + Url.Token + '/' + lawId);

  //     try {
  //       this.authedUser.token.tokenStr = tokenResp.data.token;
  //       this.authedUser.token.clientId = tokenResp.data.clientId;
  //       this.authedUser.token.userId = tokenResp.data.userId;
  //       this.authedUser.user.email = tokenResp.data.user.email;
  //       this.authedUser.user.externalId = tokenResp.data.user.externalId;
  //       this.authedUser.user.firstName = tokenResp.data.user.firstName;
  //       this.authedUser.user.lastName = tokenResp.data.user.lastName;
  //       this.authedUser.user.lawId = tokenResp.data.user.lawId;
  //       this.authedUser.user.userName = tokenResp.data.user.lawId;
  //       this.authedUser.user.title = tokenResp.data.user.title;
  //       this.authedUser.user.isMember = tokenResp.data.user.isMember;
  //       this.authedUser.user.isPcHolder = tokenResp.data.user.isPcHolder;
  //       this.authedUser.user.roles = tokenResp.data.user.roles;
  //       this.authedUser.user.impersonatedLawId = tokenResp.data.user.impersonatedLawId;
  //       this.authedUser.session.issued = Math.round(new Date(tokenResp.data['issued']).getTime() / 1000);
  //       this.authedUser.session.expires = Math.round(new Date(tokenResp.data['expires']).getTime() / 1000);

  //       return Promise.resolve(true);
  //     } catch (err) {
  //       return Promise.reject(false);
  //     }

  //   } catch (err: any) {
  //     return Promise.reject(false);
  //   }
  // }

  public async checkAuthentication(impersonatedLawId: string = null as any): Promise<AuthenticationStatus> {
    console.log('checking authentication .................')
    let tokenResp: AxiosResponse;

    try {
      if (impersonatedLawId != null) {
        tokenResp = await this.axios.get(SELF_URL + Url.Token + '/' + impersonatedLawId);
      } else {
        tokenResp = await this.axios.get(SELF_URL + Url.Token);
      }


      


      try {
        this.authedUser.token.tokenStr = tokenResp.data.token;
        this.authedUser.token.clientId = tokenResp.data.clientId;
        this.authedUser.token.userId = tokenResp.data.userId;
        this.authedUser.user.email = tokenResp.data.user.email;
        this.authedUser.user.externalId = tokenResp.data.user.externalId;
        this.authedUser.user.firstName = tokenResp.data.user.firstName;
        this.authedUser.user.lastName = tokenResp.data.user.lastName;
        this.authedUser.user.lawId = tokenResp.data.user.lawId;
        this.authedUser.user.userName = tokenResp.data.user.lawId;
        this.authedUser.user.title = tokenResp.data.user.title;
        // this.authedUser.user.isMember = tokenResp.data.user.isMember;
        // this.authedUser.user.isPcHolder = tokenResp.data.user.isPcHolder;

        // const testerRoleOnly = tokenResp.data.user.roles.filter((role: RoleType) => role == RoleType.Tester);
        // const noneTesterRole = tokenResp.data.user.roles.filter((role: RoleType) => role != RoleType.Tester);

        // if (tokenResp.data.user.impersonatedLawId) {
        //   this.authedUser.user.roles = noneTesterRole;
        // } else if (tokenResp.data.user.roles.includes(RoleType.Tester)) {
        //   this.authedUser.user.roles = testerRoleOnly;
        // } else {
        //   this.authedUser.user.roles = tokenResp.data.user.roles;
        // }

        this.authedUser.user.roles = tokenResp.data.user.roles;
        this.authedUser.session.issued = Math.round(new Date(tokenResp.data['issued']).getTime() / 1000);
        this.authedUser.session.expires = Math.round(new Date(tokenResp.data['expires']).getTime() / 1000);

        this.authedUser.user.impersonatedLawId = tokenResp.data.user.impersonatedLawId;
        this.authedUser.user.originalDisplayName = tokenResp.data.user.originalDisplayName;
        this.authedUser.user.originalFirstName = tokenResp.data.user.originalFirstName;
        this.authedUser.user.originalLastName = tokenResp.data.user.originalLastName;
        this.authedUser.user.originalLawId = tokenResp.data.user.originalLawId;
        this.authedUser.user.isTester = tokenResp.data.isTester;
        this.authedUser.user.isPrincipal = tokenResp.data.isPrincipal;
        this.authedUser.user.isMember = tokenResp.data.isMember;
        this.authedUser.user.isPcHolder = tokenResp.data.isPcHolder;
        this.authedUser.user.isExternalExaminer = tokenResp.data.isExternalExaminer;
        this.authedUser.user.isTrustContact = tokenResp.data.isTrustContact;
        this.authedUser.user.isTrustCoordinator = tokenResp.data.isTrustCoordinator;
        this.authedUser.user.lawIdUserTypeId = tokenResp.data.user.lawIdUserTypeId;
        this.authedUser.user.isInactiveExternalExaminer = tokenResp.data.user.isInactiveExternalExaminer;

        if (tokenResp.data.token) {
          this.authedUser.authenticationStatus = AuthenticationStatusType.LoggedIn;
          return Promise.resolve(AuthenticationStatusType.LoggedIn);
        } else {
          this.authedUser.authenticationStatus = AuthenticationStatusType.Unknown;
          return Promise.reject(AuthenticationStatusType.Unknown);
        }
      } catch (err) {
        this.authedUser.authenticationStatus = AuthenticationStatusType.Unknown;
        return Promise.reject(AuthenticationStatusType.Unknown);
      }

    } catch (err: any) {
      if (err.response.status === HttpStatus.UNAUTHORIZED ||
        err.response.status === HttpStatus.FORBIDDEN) {
        this.authedUser.authenticationStatus = AuthenticationStatusType.NotLogin;
        return Promise.reject(AuthenticationStatusType.NotLogin);
      } else {
        this.authedUser.authenticationStatus = AuthenticationStatusType.Unknown;
        return Promise.reject(AuthenticationStatusType.Unknown);
      }
    }
  }
}
